export default {
    pluginName: 'patent',
    backendDataType: 'PATENT',
    rowIdKey: 'PATENT_ID',
    edit: 'patent_edit',
    count: 'patent_count',
    totalCount: 'total_patent_count',
    fieldI18nKey: 'commonPatent',
    maxPerFolder: 'max_per_folder',
    maxOp: 'max_op',
    staticFields: ['PN'],
    dataId: 'PATENT_ID',
};
